export function CrawlAuthModeToggle({ authMode, setAuthMode, crawling }) {
  return (
    <div className="grid grid-cols-3 gap-2">
      <button
        type="button"
        data-testid="crawl-auth-credentials-button"
        onClick={() => setAuthMode('credentials')}
        disabled={crawling}
        className={`rounded-sm border px-3 py-2 text-xs transition-all ${
          authMode === 'credentials' ? 'border-white bg-white/10 text-white' : 'border-zinc-700 text-zinc-400 hover:border-zinc-500'
        }`}
      >
        Identifiants
      </button>
      <button
        type="button"
        data-testid="crawl-auth-cookies-button"
        onClick={() => setAuthMode('cookies')}
        disabled={crawling}
        className={`rounded-sm border px-3 py-2 text-xs transition-all ${
          authMode === 'cookies' ? 'border-white bg-white/10 text-white' : 'border-zinc-700 text-zinc-400 hover:border-zinc-500'
        }`}
      >
        Cookies
      </button>
      <button
        type="button"
        data-testid="crawl-auth-google-button"
        onClick={() => setAuthMode('google')}
        disabled={crawling}
        className={`rounded-sm border px-3 py-2 text-xs transition-all ${
          authMode === 'google' ? 'border-white bg-white/10 text-white' : 'border-zinc-700 text-zinc-400 hover:border-zinc-500'
        }`}
      >
        Google
      </button>
    </div>
  );
}
